import React, { useState } from "react";
import { toast } from "react-hot-toast";
import close from "../../../../assets/img/icons/Vector copy.svg";
import useFetch from "../../../../hooks/useAxios";
import Button from "../../../shared/Button";

const CityModal = ({
  closeModal,
  chosenCity,
  ChoseState,
  setIsState,
  setChoseCity,
  notshowCount=false,
  setchoseCityId,choseCityId,choseoneCity=false
}) => {
  console.log(ChoseState)
  const [CityList, setCityList] = useState(ChoseState ? ChoseState[0].cities  : []); //city //start //end //count

  const findState = e => {
    if(ChoseState){
      setCityList(
        ChoseState[0].cities.filter(i => i.title.startsWith(e.target.value))
      );
    }
 
    //setStateinfo(StateResults.filter(i=>i.name.startsWith(e.target.value)))
    // if(e.target.value === ""){
    //     setStateinfo([...StateResults])
    // }
  };
  const chooseCities = (id) => {
    const newcity = CityList.filter(i => i.id === id);
    if(choseCityId.includes(id)){
      setchoseCityId(choseCityId.filter(i=>i !== id))
       setChoseCity(chosenCity.filter(i => i.id !== id));

    }else if(chosenCity.length <= 10){

      if(choseoneCity){
        setChoseCity(newcity);
        setchoseCityId(prev => [id]);
     
      }else{
        setChoseCity(prev => [...prev, ...newcity]);
        setchoseCityId(prev => [...prev, id]);
      }
   

    }else{
      toast.error("بیشتر از ده شهر قابل انتخاب نمیباشد.")
    }
   
   
  };
  console.log(chosenCity)
  return (
    <div className=" GuestCount Instancedelivery">
      <div className="flex justify-between  items-center">
        <div className="flex justify-between  items-center gap-[8px]">
          <h2 className="text-[#292D32] text-[20px] font-[700]">
            لیست شهر های {ChoseState ? ChoseState[0].name : null}
          </h2>
        </div>

        <buttonon onClick={()=>closeModal()}>
          <img src={close} />
        </buttonon>
      </div>
      <div>
        <hr className="my-[10px]" />
        <div className={`Input relative `}>
          <input
            placeholder="شهر مورد نظر را جستجو کنید"
            onChange={e => findState(e)}
          />
        </div>
        <div className="StateModal-body CityModal--body my-[10px] pb-[80px]">
          {CityList.map(i =>
            <div>
              <div
                className={`CityModal--box ${choseCityId.includes(i.id)
                  ? "CityModal--box--active "
                  : ""}`}
                  key={i.id}
                onClick={() => chooseCities(i.id)}
              >
                <div className="checkbox-city" />
                <div>
                  <h4>
                    {i.title}
                  </h4>
                 {!notshowCount &&  <p>
                    {i.residences_count} اقامتگاه دارد
                  </p>}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="flex StateModal-buttonrow">
          <Button varient="white" onClick={() => setIsState(true)}>
            برگشت{" "}
          </Button>

          <Button varient="primary" onClick={()=>closeModal()}>تایید مقصد</Button>
        </div>
      </div>
    </div>
  );
};

export default CityModal;
